import { client } from ".";

export const login = async (mobile, password) => {
  const {
    data: { data },
    status,
  } = await client.post(`/api/astrologer/login`, { mobile, password });
  return { data, status };
};

export const logout = async (astrologerId, accessToken) => {
  try {
    const { status } = await client.post(
      `/api/astrologer/logout/${astrologerId}`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    return { status };
  } catch (err) {
    console.log(err.response);
  }
};
